
import { fetchConToken } from "../../../helpers/fetch";
import { AppDispatch } from "../../store";

import { endLoadingSeccion, SeccionState, setSecciones } from "./seccionSlice";

type Activo = {
    cid: string
    mid: string
    bid: string
    sid: string
    grupo: number 
    activo: boolean | undefined
}

export const obtenerSeccionesModulo = (mid: string) => {

    return async (dispatch: AppDispatch, getState: any) => {

        const { usuario } = getState().usuario;
        const { curso } = getState().curso;

        const cursoUsuario = usuario.cursos.find((item: any) => item.cid === curso.cid)

        try {
            const resp = await fetchConToken(`seccion/obtener/${mid}/${cursoUsuario.grupo}`);
            const body = await resp.json();

            if (body.ok) {
                const { secciones } = body;
                
                dispatch(setSecciones(secciones));
                dispatch(endLoadingSeccion())
                return 
            }
        } catch (error) {
            console.log(error)
        }
    }
}

export const obtenerSeccionesBloque = (mid: string, bid: string) => {

    return async (dispatch: AppDispatch) => {

        try {
            const resp = await fetchConToken(`seccion/obtener/${mid}/${bid}`);
            const body = await resp.json();

            if (body.ok) {
                const { secciones } = body;
                dispatch(setSecciones(secciones));
                dispatch(endLoadingSeccion())
                return 
            }
        } catch (error) {
            console.log(error)
        }
    }
}

export const actualizarSeccionEjercicioUsuario = (eid: String, estado: Boolean) => {

    return async (dispatch: any, getState: any) => {

        const { secciones } = getState().seccion;

        try {
            const resp = await fetchConToken(`seccion/actualizar-seccion-ejercicio-usuario/${eid}`, { estado: estado }, 'PUT');
            const body = await resp.json();

            if (body.ok) {
                const { ejercicioSeccionUsuarioActualizado } = body;

                const seccionesActualizada = secciones.map((item: SeccionState) => {
                    const ejercicioEncontrado = item.ejercicios?.find(ejercicio => ejercicio.eid === ejercicioSeccionUsuarioActualizado.eid);

                    if (ejercicioEncontrado) {
                        return ({
                            ...item, 
                            ejercicios: item.ejercicios?.map(ejercicio => 
                                    ejercicio.eid === ejercicioSeccionUsuarioActualizado.eid ? {...ejercicio, estado: estado} : ejercicio
                                )
                        })
                    }

                    return item
                });

                dispatch(setSecciones(seccionesActualizada))
            }
        } catch (error) {
            console.log(error)
        }

    }
}

export const actualizarActivoSeccion = (seccionActivoActualizado: Activo) => {

    

    return async (dispatch: AppDispatch, getState: any) => { 
        
        const { secciones } = getState().seccion;

        const seccionesActualizada = secciones.map((item: SeccionState) => (
            item.sid === seccionActivoActualizado.sid ? 
            { ...item, activo: seccionActivoActualizado.activo } : item
        ));

        dispatch(setSecciones(seccionesActualizada))

    }
}

// ADMINISTRADOR
export const crearSeccion = (seccion: object) => {

    return async (dispatch: AppDispatch, getState: any) => {

        const { secciones } = getState().seccion;

        try {
            const resp = await fetchConToken(`seccion/crear`, seccion, 'POST');
            const body = await resp.json();

            if (body.ok) {
                const { seccionCreada } = body;
                const seccionesActualizada = [...secciones, {...seccionCreada, diapositivas: []}]
                dispatch(setSecciones(seccionesActualizada))
                return 
            }
        } catch (error) {
            console.log(error)
        }
    }
}

export const eliminarSeccion = (sid: string) => {

    return async (dispatch: AppDispatch, getState: any) => {

        const { secciones } = getState().seccion;

        try {
            const resp = await fetchConToken(`seccion/eliminar/${sid}`, { sid: sid }, 'DELETE');
            const body = await resp.json();

            if (body.ok) {
                const { seccionEliminada } = body;
                const seccionesActualizada = secciones.filter((item: SeccionState) => item.sid !== seccionEliminada.sid);
                dispatch(setSecciones(seccionesActualizada))
                return 
            }
        } catch (error) {
            console.log(error)
        }
    }
}

export const actualizarSeccion = (seccion: SeccionState) => {

    return async (dispatch: AppDispatch, getState: any) => {

        const { sid } = seccion; 

        const { secciones } = getState().seccion;

        try {
            const resp = await fetchConToken(`seccion/actualizar/${sid}`, seccion, 'PUT');
            const body = await resp.json();

            if (body.ok) {
                const { seccionActualizada } = body;

                const seccionesActualizada = secciones.map((item: SeccionState) => 
                
                    item.sid === sid ? 
                    {
                        ...seccionActualizada, 
                        diapositivas: item?.diapositivas ? item?.diapositivas : []
                    } : item
                );

                dispatch(setSecciones(seccionesActualizada))
                return 
            }
        } catch (error) {
            console.log(error)
        }
    }
}
